import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { AreaTreeStoreContext } from './context'
import { AreaTreeStoreProviderProps } from './interface'
import { createAreaTreeStore } from './store/createStore'
import { AreaTreeStoreUpdater } from './StoreUpdater'

export const AreaTreeStoreProvider = ({
  children,

  /* -------------------------------------------------------------------------- */
  /*                         AreaTreeStoreUpdater Props                         */
  /* -------------------------------------------------------------------------- */
  value,
  onChange
}: PropsWithChildren<AreaTreeStoreProviderProps>) => {
  const store = useCreation(() => createAreaTreeStore(), [])

  return (
    <AreaTreeStoreContext value={store}>
      <AreaTreeStoreUpdater value={value} onChange={onChange} />
      {children}
    </AreaTreeStoreContext>
  )
}
